import { render, staticRenderFns } from "./CampaignType.vue?vue&type=template&id=28ce9174"
import script from "./CampaignType.vue?vue&type=script&lang=js"
export * from "./CampaignType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports